/* src/app/shared-module/components/subscription-expired/subscription-expired.component.scss */
h2 {
  margin: 0px;
  line-height: initial;
}
h4 {
  line-height: initial;
  margin: 0 0 0px !important;
}
h3 {
  line-height: initial;
}
.button {
  background-color: #1c87c9;
  border: none;
  color: #eeeeee;
  cursor: pointer;
  display: inline-block;
  font-family: sans-serif;
  padding: 10px 18px;
  text-align: center;
  text-decoration: none;
}
@keyframes glowing {
  0% {
    background-color: #e35655;
    box-shadow: 0 0 5px #e35655;
  }
  50% {
    background-color: #e01c1b;
    box-shadow: 0 0 20px #e01c1b;
  }
  100% {
    background-color: #e35655;
    box-shadow: 0 0 5px #e35655;
  }
}
.button {
  animation: glowing 1300ms infinite;
}
.div-n-found {
  height: 100%;
  display: flex;
  align-items: center;
}
/*# sourceMappingURL=subscription-expired.component.css.map */
